import type { ThemeData } from '@group-link-one/gl-components';
import { WaterDarkTheme } from './Themes/Water/Variants/WaterDark';
import { WaterLightTheme } from './Themes/Water/Variants/WaterLight';

const WaterThemes: Record<string, ThemeData> = {
  'water-light': WaterLightTheme,
  'water-dark': WaterDarkTheme,
};

export { WaterThemes };
